/* global App */

(function(angular) {
	'use strict';
	/**
	 * Notification service
	 */
//	if (angular.isDefined(App) && App.optLockFn === null) {
//		App.optLockFn = function() {
//			location.reload();
//		};
//	}
	var core = angular.module('Core');
	core.service('NotificationService', function ($rootScope, $log, toaster, $translate) {
		var instance = this;

		var optLockFn = null;

		this.setOptLockFunction = function(fn) {
			optLockFn = fn;
		};

		var uniqueNotificationKeys = {};

		/**
		 * Examples:
		 * notificationService.notify("SUCCESS", "SUCCESS", "SUCCESS Level");
		 * notificationService.notify("ERROR", "ERROR", "ERROR Level");
		 * notificationService.notify("WARN", "WARNING", "WARNING Level");
		 * notificationService.notify("INFO", "INFO", "INFO Level");
		 *
		 * @param {String} level SUCCESS, ERROR, WARN, INFO
		 * @param {String} title Title of the box
		 * @param {String} html HTML Contents of the box
		 */
		this.notify = function(level, title, html) {
			switch (level) {
				case 'SUCCESS':
					toaster.pop('success', title, html, 5000, 'trustedHtml');
					break;
				case 'ERROR':
					toaster.pop('error', title, html, 15000, 'trustedHtml');
					break;
				case 'INFO':
					toaster.pop('note', title, html, 5000, 'trustedHtml');
					break;
				case 'WARN':
					toaster.pop('warning', title, html, 15000, 'trustedHtml');
					break;
			}
		};
		this.showAjaxErrorMessage = function(status, title, url) {
			var ttl = title;
			if (!ttl) {
				ttl = $translate.instant('error.ajax.message');
			}
			var message = $translate.instant('error.ajax.status') + ': ' + status;
			instance.notify('ERROR', ttl, message);

			$log.warn('NotificationService: request failed. Status: ' + status + ' URL: ' + url);
		};

		this.notifyUniqueError = function(key) {
			if (uniqueNotificationKeys[key]) {
				return;
			}

			instance.notify('ERROR', '', $translate.instant(key));
		};

		var isBusinessError = function(error) {
			return error.errorType.indexOf('ERR_BUS_') === 0;
		};

		var isGeneralError = function(error) {
			return  error.errorType.indexOf('ERR_GEN_') === 0;
		};

		var showBusinessErrorMessage = function(status, error) {
			var title = $translate.instant('error.business.' + error.errorType);

			var messageKey = 'error.business.' + error.errorType + '.message';
			var message = $translate.instant(messageKey);
			if (message === messageKey) {
				message = null;
			}
			instance.notify('ERROR', title, message);
		};

		var showDataNotFoundErrorMessage = function(error) {
			var title = $translate.instant('error.ajax.status.' + 404);
			var clazz = null;
			var id = null;
			if (error.parameters) {
				if (error.parameters.length > 0) {
					clazz = error.parameters[0];
				}
				if (error.parameters.length > 1) {
					id = error.parameters[1];
				}
			}

			var htmlMessage = '';
			if (clazz) {
				var paths = clazz.split('\.');
				clazz = paths[paths.length - 1];
				htmlMessage += $translate.instant('error.resource') + ': ' + clazz;
				if (id) {
					htmlMessage += ', ' + $translate.instant('error.id') + ': ' + id;
				}
			}

			instance.notify('ERROR', title, htmlMessage);
		};

		var showDependanceNotFoundErrorMessage = function (error) {
			var title = $translate.instant('error.code.' + error.errorType);
			var clazz = null;
			var id = null;
			if (error.parameters) {
				if (error.parameters.length > 0) {
					clazz = error.parameters[0];
				}
				if (error.parameters.length > 1) {
					id = error.parameters[1];
				}
			}

			var htmlMessage = '';
			if (clazz) {
				var paths = clazz.split('\.');
				clazz = paths[paths.length - 1];
				htmlMessage += $translate.instant('error.resource') + ': ' + clazz;
				if (id) {
					htmlMessage += ', ' + $translate.instant('error.id') + ': ' + id;
				}
			}

			instance.notify('ERROR', title, htmlMessage);
		};

		var showNotAuthorizedErrorMessage = function(error) {
			var title = $translate.instant('error.ajax.status.' + 403);
			instance.notify('ERROR', title);
		};

		var showOptLockErrorMessage = function(error) {
			var title = $translate.instant('error.ajax.status.' + 409);

			var fn = function() {
				location.reload();
			};
			if (optLockFn) {
				fn = optLockFn;
			}

			App.optLockFn = optLockFn;

			var message = '<a type="button" class="btn btn-default btn-glyph" onclick="App.optLockFn()" style="color: black;">' +
					$translate.instant('error.optlock.reload') + ' <span class="glyphicon glyphicon-refresh"></span></a>';

			instance.notify('WARN', title, message);
		};

		this.showWarnWithReload = function (title, message) {
			App.realoadFn = function () {
				location.reload();
			};
			var htmlMessage = message + '<br><a type="button" class="btn btn-default btn-glyph" onclick="App.realoadFn()" style="color: black;">' +
					$translate.instant('error.optlock.reload') + ' <span class="glyphicon glyphicon-refresh"></span></a>';

			instance.notify('WARN', title, htmlMessage);
		};

		this.showApplicationErrorMessage = function(status, url, error) {
			if (isBusinessError(error)) {
				showBusinessErrorMessage(status, error);
			} else {
				switch (error.errorType) {
					case 'ERR_GEN_10':
						showDataNotFoundErrorMessage(error);
						break;
					case 'ERR_GEN_20':
						showOptLockErrorMessage(error);
						break;
					case 'ERR_GEN_30':
						showNotAuthorizedErrorMessage(error);
						break;
					case 'ERR_GEN_42':
						showDependanceNotFoundErrorMessage(error);
						break;
					default:
						var message = '';
						if (isGeneralError(error)) {
							message = $translate.instant('error.code') + ': ' + $translate.instant('error.code.' + error.errorType);
							instance.notify('ERROR', '', message);
						} else {
							var title = $translate.instant('error.ajax.status.' + status);
							message = $translate.instant('error.code') + ': ' + error.errorType;
							instance.notify('ERROR', title, message);
						}
						break;
				}
			}

			// Log data...
			var params = ' ';
			if (error.parameters) {
				for (var i = 0; i < error.parameters.length; i++) {
					params += error.parameters[i] + ' ';
				}
			}
			$log.warn('NotificationService: request failed. Status: ' + status + ' Error type: ' + error.errorType +
					' Params: [' + params + '] message: ' + error.message + ', url: ' + url);
		};

		this.showOptimisticLock = function(message, fn) {
			var msg;
			if (message) {
				msg = message;
			} else {
				msg = $translate.instant('error.optlock.message');
			}

			if (fn !== undefined && fn !== null) {
				$rootScope.optLockFn = fn;
			} else {
				$rootScope.optLockFn = function() {
					location.reload();
				};
			}

			msg +=
					'<br /><br />' +
					'<a type="button" class="btn btn-default btn-glyph" onclick="App.optLockFn()" style="color: black;">' +
					$translate.instant('error.optlock.reload') + ' <span class="glyphicon glyphicon-refresh"></span></a>';
			this.notify('WARN', null, msg);

		};
		this.clear = function() {
			toaster.clear();
		};
	});
})(angular);
